import { CloseIcon } from "@chakra-ui/icons";
import {
  Button,
  Drawer,
  DrawerBody,
  DrawerContent,
  DrawerFooter,
  DrawerHeader,
  DrawerOverlay,
  IconButton,
} from "@chakra-ui/react";
import Spinner from "common/components/spinner/Spinner";
import { useFormik } from "formik";
import { useState } from "react";
import { toast } from "react-toastify";
import { postApi } from "common/services/api";
import { generateValidationSchema } from "services/Crm/utils";
import CustomForm from "common/utils/customForm";
import * as yup from "yup";
import { singularizeLastWord } from "services/Crm/utils/calcUtils";
import { constant } from "common/constant";
import { globalStyles } from "common/theme/styles";

const Add = (props) => {
  const [isLoading, setIsLoading] = useState(false);

  const initialFieldValues = Object.fromEntries(
    (props?.moduleData?.fields || []).map((field) => [field?.name, ""])
  );

  const initialValues = {
    ...initialFieldValues,
    createBy: JSON.parse(localStorage.getItem("user"))._id,
  };

  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: yup
      .object()
      .shape(generateValidationSchema(props?.moduleData?.fields)),
    onSubmit: (values, { resetForm }) => {
      AddData();
    },
  });

  const {
    errors,
    touched,
    values,
    handleBlur,
    handleChange,
    handleSubmit,
    setFieldValue,
  } = formik;

  const AddData = async () => {
    try {
      setIsLoading(true);
      let response = await postApi("api/form/add", {
        ...values,
        moduleId: props?.moduleData?._id,
      });
      if (response.status === 200) {
        props.onClose();
        formik.resetForm();
        props.setAction((pre) => !pre);
      }
    } catch (e) {
      toast.error("Something went wrong");
    } finally {
      setIsLoading(false);
    }
  };

  const handleCancel = () => {
    formik.resetForm();
    props.onClose();
  };

  return (
    <div>
      <Drawer isOpen={props.isOpen} size={props.size}>
        <DrawerOverlay />
        <DrawerContent>
          <DrawerHeader
            alignItems={"center"}
            justifyContent="space-between"
            display="flex"
          >
            {constant.create} {singularizeLastWord(props.title)}
            <IconButton onClick={props.onClose} icon={<CloseIcon />} />
          </DrawerHeader>
          <DrawerBody>
            <CustomForm
              moduleData={props.moduleData}
              values={values}
              setFieldValue={setFieldValue}
              handleChange={handleChange}
              handleBlur={handleBlur}
              errors={errors}
              touched={touched}
            />
          </DrawerBody>
          <DrawerFooter>
            <Button
              sx={{ textTransform: "capitalize" }}
              size="sm"
              disabled={isLoading ? true : false}
              variant="brand"
              type="submit"
              onClick={handleSubmit}
            >
              {isLoading ? (
                <Spinner
                  size={20}
                  paddingRight={5}
                  border={`3px solid ${globalStyles.colors.loaderBorder}`}
                  borderTop={`1px solid ${globalStyles.colors.transparent}`}
                />
              ) : (
                ""
              )}{" "}
              {constant.save}
            </Button>
            <Button
              variant="outline"
              colorScheme="red"
              size="sm"
              sx={{
                marginLeft: 2,
                textTransform: "capitalize",
              }}
              onClick={handleCancel}
            >
              Close
            </Button>
          </DrawerFooter>
        </DrawerContent>
      </Drawer>
    </div>
  );
};

export default Add;
